
import React from 'react'
import { Grid, Column, iconCell } from 'components/grid'
import { localized, withDialogs, dialogTypes } from 'decorators'

export default withDialogs(localized(({ dataSource, localize, persistor, showDialog }) => {
  const handleOnRowClick = React.useCallback((row) => {
    showDialog({
      dialogType: dialogTypes.winesInStockDetail,
      context: {
        title: localize('winesInStock.bottlesOfWineInStockTitle'),
        wineId: row.dataItem.id
      }
    })
  }, [showDialog, localize])
  return (
    <Grid
        dataSource={dataSource}
        pageSizes={[5, 10, 20, 50, 100]}
        onRowClick={handleOnRowClick}
        persistor={persistor}>
        <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
        <Column field='name' title={localize('bottles.wineName')} cell={iconCell({ icon: 'glass' })} width='270px' />
        <Column field='vintage' title={localize('wines.vintage')} filter='numeric' width='220px' />
        <Column field='producerName' title={localize('wines.producer')} width='220px' />
        <Column field='suppliersName' title={localize('winesInStock.suppliers')} width='220px' />
        <Column field='storageName' title={localize('winesInStock.storagePlace')} width='250px' />
        <Column field='bottlesInStockCount' filter='numeric' title={localize('winesInStock.bottlesInStockCount')} width='200px' />
    </Grid>
  )
}))
